import React from "react";
import mdAndroidIntegration from "../markdown/android-integration.md";
import Document from "../Document";

const AndroidIntegration = () => {
  return <Document md={mdAndroidIntegration} />;
};

export default AndroidIntegration;
